import React from 'react';
import Axios from 'axios';
import { Alert } from "../Components/Alert";

var user_browser;
var user_input;
var error_messages;
var component;

export default class SubmissionHandler {
  constructor(errors) {
    error_messages = errors;
  }

  BuildARPrevalidation(c) {
    component = c;
    const input = component.state.user_input;
    user_browser = component.state.user_browser;
    user_input = {
      referrals: input.referrals,
      other_referral: input.other_referral,
      conditions: input.conditions,
      member_id: input.member_id,
      group_number: input.group_number
    }
    return this;
  }

  BuildFLPrevalidation(c) {
    component = c;
    const input = component.state.user_input;
    user_browser = component.state.user_browser;
    user_input = {
      referrals: input.referrals,
      other_referral: input.other_referral,
      conditions: input.conditions,
      member_id: input.member_id
    }
    return this;
  }

  BuildHIPrevalidation(c) {
    component = c;
    const input = component.state.user_input;
    user_browser = component.state.user_browser;
    user_input = {
      referrals: input.referrals,
      other_referral: input.other_referral,
      conditions: input.conditions,
      primary_first_name: input.primary_first_name,
      primary_last_name: input.primary_last_name,
      member_first_name: input.member_first_name,
      member_last_name: input.member_last_name,
      member_id: input.member_id,
      member_dob: input.member_dob
    }
    return this;
  }

  BuildARValidation(c) {
    component = c;
    const input = component.state.user_input;
    const location = component.props.location;
    user_input = {
      referrals: location.user_input.referrals,
      other_referral: location.user_input.other_referral,
      conditions: location.user_input.conditions,
      member_id: location.user_input.member_id,
      group_number: location.user_input.group_number,
      pregnancy_due_date: input.pregnancy_due_date,
      primary_first_name: input.primary_first_name,
      primary_last_name: input.primary_last_name,
      member_first_name: input.member_first_name,
      member_last_name: input.member_last_name,
      member_dob: input.member_dob,
      member_address: input.member_address,
      member_city: input.member_city,
      member_state: input.member_state,
      member_zip: input.member_zip,
      member_home_phone: input.member_home_phone,
      member_cell_phone: input.member_cell_phone,
      member_email: input.member_email,
      ecc: input.ecc,
      physician_first_name: input.physician_first_name,
      physician_last_name: input.physician_last_name,
      physician_phone: input.physician_phone,
      physician_license: input.physician_license,
      physician_license_state: input.physician_license_state,
      physician_address: input.physician_address,
      physician_city: input.physician_city,
      physician_state: input.physician_state,
      physician_zip: input.physician_zip,
      affirmation: input.affirmation
    }
    return this;
  }

  BuildFLValidation(c) {
    component = c;
    const input = component.state.user_input;
    const location = component.props.location;
    user_input = {
      referrals: location.user_input.referrals,
      other_referral: location.user_input.other_referral,
      conditions: location.user_input.conditions,
      member_id: location.user_input.member_id,
      pregnancy_due_date: input.pregnancy_due_date,
      primary_first_name: input.primary_first_name,
      primary_last_name: input.primary_last_name,
      member_first_name: input.member_first_name,
      member_last_name: input.member_last_name,
      member_dob: input.member_dob,
      member_address: input.member_address,
      member_city: input.member_city,
      member_state: input.member_state,
      member_zip: input.member_zip,
      member_home_phone: input.member_home_phone,
      member_cell_phone: input.member_cell_phone,
      member_email: input.member_email,
      ecc: input.ecc,
      physician_first_name: input.physician_first_name,
      physician_last_name: input.physician_last_name,
      physician_phone: input.physician_phone,
      physician_license: input.physician_license,
      physician_license_state: input.physician_license_state,
      physician_address: input.physician_address,
      physician_city: input.physician_city,
      physician_state: input.physician_state,
      physician_zip: input.physician_zip,
      affirmation: input.affirmation
    }
    return this;
  }
  
  BuildHIValidation(c) {
    component = c;
    const input = component.state.user_input;
    const location = component.props.location;
    user_input = {
      referrals: location.user_input.referrals,
      other_referral: location.user_input.other_referral,
      conditions: location.user_input.conditions,
      member_id: location.user_input.member_id,
      pregnancy_due_date: input.pregnancy_due_date,
      primary_first_name: location.user_input.primary_first_name,
      primary_last_name: location.user_input.primary_last_name,
      member_first_name: location.user_input.member_first_name,
      member_last_name: location.user_input.member_last_name,
      member_dob: location.user_input.member_dob,
      member_address: input.member_address,
      member_city: input.member_city,
      member_state: input.member_state,
      member_zip: input.member_zip,
      member_home_phone: input.member_home_phone,
      member_cell_phone: input.member_cell_phone,
      member_email: input.member_email,
      ecc: input.ecc,
      physician_first_name: input.physician_first_name,
      physician_last_name: input.physician_last_name,
      physician_phone: input.physician_phone,
      physician_license: input.physician_license,
      physician_license_state: input.physician_license_state,
      physician_address: input.physician_address,
      physician_city: input.physician_city,
      physician_state: input.physician_state,
      physician_zip: input.physician_zip,
      affirmation: input.affirmation
    }
    return this;
  }

  handleSubmit(e) {
    e.preventDefault();
    let { errors, is_loading, success, endpoint } = component.state;
    component.setState({ is_loading: true });

    Axios.post(endpoint, {
      user_browser, user_input
    }).then(result => {
      let error_messages = result.data.error_messages;
      errors = [];
      if (error_messages.length > 0) {
        error_messages.map(error => {
          errors[error.error_code] = (
            <Alert type="alert-danger"
              text={error.message}
            />);
        });
        is_loading = false;
        component.setState({ is_loading, errors });
      } else {
        success = true;
        is_loading = false;
        component.setState({ is_loading, errors, success });
      }
    }).catch(error => {
      errors["default_error"] = (<Alert
        type="alert-danger"
        text={error_messages.default_error}
      />);
    });
  }
}